module.exports = __webpack_public_path__ + "img/00a79fd397a0eb6282c218b9da1e8f1a.png";